import React from 'react';
import { Grid } from '@material-ui/core';

export const collegeChecklistItems = [
  {
    key: 'secedTakeACTOrAccuplacer',
    label: 'Take or retake ACT/Placement Testing/Met requirements',
    confirmKey: 'confirmSecedTakeACTOrAccuplacer',
    points: 3,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
    extra: (form, auth, act, classes) => (
      <Grid container direction="row" style={{ margin: '0 0 10px 60px' }}>
        <Grid item xs={12} sm={3} md={2} lg={2}>
          <label>ACT Score: {act}</label>
        </Grid>
        <Grid item xs={9} sm={8} md={10} lg={10}>
          <label className={classes?.unprintedContent}>
            {auth?.roles?.includes('STUDENT') && <em>*Your ACT score can be entered on the Personal Information page.</em>}
          </label>
        </Grid>
      </Grid>
    ),
  },
  {
    key: 'collegeExploreVisit',
    label: 'Explore and/ or visit colleges/community colleges to which you might want to apply. (Could be virtual)',
    confirmKey: 'confirmCollegeExploreVisit',
    points: 3,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeFsaAccount',
    label: 'Go to studentaid.gov and create a Federal Student Aid Account.  (One for you and send invite to your parent, if applicable.)',
    confirmKey: 'confirmCollegeFsaAccount',
    points: 3,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeFafsa',
    label: 'Complete the FAFSA at studentaid.gov (must be completed before submitting scholarship applications)',
    confirmKey: 'confirmCollegeFafsa',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeSubmitApps',
    label: 'Submit two or more completed college applications.',
    confirmKey: 'confirmCollegeSubmitApps',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeForwardScores',
    label: 'Ensure ACT/Placement Testing scores are forwarded to the schools to which you have applied.',
    confirmKey: 'confirmCollegeForwardScores',
    points: 2.5,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeForwardFafsa',
    label: 'Ensure FAFSA information is sent to the schools to which you have applied.',
    confirmKey: 'confirmCollegeForwardFafsa',
    points: 2.5,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeLocateSai',
    label: 'Locate the Student Aid Index (SAI) in your email.',
    confirmKey: 'confirmCollegeLocateSai',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegePrintSai',
    label: 'Print Student Aid Index (to be submitted with your Boys Town scholarship application) and keep a copy of it in your accordion file.',
    confirmKey: 'confirmCollegePrintSai',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeSubmitScholarshipApps',
    label: 'Submit two or more completed college scholarship applications to the school(s) to which you are applying.',
    confirmKey: 'confirmCollegeSubmitScholarshipApps',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeExternalScholarships',
    label:
      "Explore and complete external college scholarship applications (i.e., Buffet Scholarship, DJ Heros, Barriento's, Goodrich, a good source would be scholarship quest, etc.).",
    confirmKey: 'confirmCollegeExternalScholarships',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeAcceptanceNotifications',
    label: 'Gather acceptance notifications and related communication and file in organization system.',
    confirmKey: 'confirmCollegeAcceptanceNotifications',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeStudentIdPassword',
    label: 'Once accepted, obtain student ID/password used to log into your school account. Store this ID and password in your organization system',
    confirmKey: 'confirmCollegeStudentIdPassword',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeReviewFinancialAid',
    label: 'Log into the school account and review financial aid documents. Keep a copy of these documents in your organization system',
    confirmKey: 'confirmCollegeReviewFinancialAid',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeCheckOtherDocs',
    label: 'Log into the school account and check for other documents that need to be submitted to the school.',
    confirmKey: 'confirmCollegeCheckOtherDocs',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeFinalizeHousing',
    label:
      'To attend school you must have a place to live.  Finalize your housing options (on campus or off campus) and, if applicable, apply for housing and submit deposits. Keep a copy of the receipts and/or documents in your organization system',
    confirmKey: 'confirmCollegeFinalizeHousing',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeRequestTranscripts',
    label: 'Request final transcripts be submitted to the college you are going to attend.',
    confirmKey: 'confirmCollegeRequestTranscripts',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'collegeOrientationDates',
    label:
      'Note the dates for college summer orientation and class registration on your calendar and keep a copy of these dates in your organization system',
    confirmKey: 'confirmCollegeOrientationDates',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
];
